import { render, staticRenderFns } from "./MessageDisplay.vue?vue&type=template&id=16d1ac1c&scoped=true"
import script from "./MessageDisplay.vue?vue&type=script&lang=js"
export * from "./MessageDisplay.vue?vue&type=script&lang=js"
import style0 from "./MessageDisplay.vue?vue&type=style&index=0&id=16d1ac1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1ac1c",
  null
  
)

export default component.exports